<template>
    <div id="about">
        <div class="div-block-4"></div>
        <div data-collapse="medium" data-animation="default" data-duration="400" class="header-navigation fixed w-nav">
            <NetworkStatus/>
            <HeaderMenu/>
        </div>

        <div class="section section-color center">
            <div class="w-container" style="padding:40px 0 0 0">
                <h1 class="key-number">{{$t('about')}} LocalScale</h1>
                <div class="sub-header">{{$t('local_ads_powered_by_ai')}}</div>
            </div>
        </div>

        <div class="section small-margins-all-around">
            <div id="content" class="w-container main-content">
                <div id="company" class="index-section">
                    <div class="index-section-wrapper page-content">
                        <div class="sqs-layout">
                            <div class="row sqs-row">
                                <div class="col sqs-col-12">
                                    <div class="sqs-block center">
                                        <p style="font-size: 20px"><b>Since 2015, LocalScale has been trusted by thousands of businesses to help them grow and find local customers. We’re on a mission to help you scale your business with ads targeting local customers in the cities and zip codes that matter to you.</b></p>
                                    </div>
                                    <div class="sqs-block center">
                                        <p style="font-size: 16px">Our platform is powered by advanced machine learning algorithms and has delivered billions of ads and millions of leads. We believe businesses of all sizes should be able to harness AI-powered advertising technology, with precise targeting to more than 19k local cities and 41k zip codes.</p>
                                    </div>
                                    <div class="sqs-block center">
                                        <p style="font-size: 16px">We’re confident that you’ll fall in love with the ability to find local customers at a better cost than the big guys.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="section section-color center">
            <div class="w-container" style="padding:10px 0 10px 0">
                <div class="key-number" style="padding-top: 0">{{$t('localscales_partners')}}</div>
            </div>
        </div>

        <div class="section">
            <div class="center w-container">
                <div class="integrations">
                    <div class="w-row">
                        <div class="column w-col w-col-3"><a href="#" class="integration-item w-inline-block"><img src="images/exchanges/Google.png" alt="Google" class="padding"></a></div>
                        <div class="column w-col w-col-3"><a href="#" class="integration-item w-inline-block"><img src="images/exchanges/Magnite.png" alt="Magnite" class="padding"></a></div>
                        <div class="column w-col w-col-3"><a href="#" class="integration-item w-inline-block"><img src="images/exchanges/Index-Exchange-Logo.png" alt="Index Exchange" class="padding"></a></div>
                        <div class="column w-col w-col-3"><a href="#" class="integration-item w-inline-block"><img src="images/exchanges/PubMatic+Cropped.png" alt="PubMatic" class="padding"></a></div>
                    </div>
                    <div class="w-row">
                        <div class="column w-col w-col-3"><a href="#" class="integration-item w-inline-block"><img src="images/exchanges/Vungle.png" alt="Vungle" class="padding"></a></div>
                        <div class="column w-col w-col-3"><a href="#" class="integration-item w-inline-block"><img src="images/exchanges/OpenX+v2.png" alt="OpenX" class="padding"></a></div>
                        <div class="column w-col w-col-3"><a href="#" class="integration-item w-inline-block"><img src="images/exchanges/Smaato-logo.jpg" alt="Smaato" class="padding"></a></div>
                        <div class="column w-col w-col-3"><a href="#" class="integration-item w-inline-block"><img src="images/exchanges/Media.net.jpg" alt="Media.net" class="padding"></a></div>
                    </div>
                    <div class="w-row">
                        <div class="column w-col w-col-3"><a href="#" class="integration-item w-inline-block"><img src="images/exchanges/InMobi.png" alt="InMobi" class="padding"></a></div>
                        <div class="column w-col w-col-3"><a href="#" class="integration-item w-inline-block"><img src="images/exchanges/AdColony.png" alt="AdColony" class="padding"></a></div>
                        <div class="column w-col w-col-3"><a href="#" class="integration-item w-inline-block"><img src="images/exchanges/Algorix.jpg" alt="Algorix" class="padding"></a></div>
                        <div class="column w-col w-col-3"><a href="#" class="integration-item w-inline-block"><img src="images/exchanges/LoopMe.png" alt="LoopMe" class="padding"></a></div>
                    </div>
                </div>
            </div>
        </div>

        <div class="section section-color center">
            <div class="w-container">
                <div class="key-number" style="padding-top: 0">Our Leadership</div>
                <div class="sub-header">{{$t('mobile_adtech_veterans')}}</div>
            </div>
        </div>

        <div class="section no-margins">
            <div class="w-container main-content">
                <div id="team" class="index-section">
                    <div class="index-section-wrapper page-content">
                        <div class="w-row employee-row">
                            <div class="col w-col w-col-12">
                                <div class="sqs-block">
                                    <div>
                                        <p style="text-align:center;margin-top:50px;white-space:pre-wrap;" class="">{{$t('the_team_behind_localscale')}}</p>
                                    </div>
                                </div>
                            </div>

                            <div class="w-row employee-row">
                                <div class="column w-col w-col-3">
                                    <div class="sqs-block sqs-block-image">
                                        <div class="image-block-outer-wrapper">
                                            <a href="https://www.linkedin.com/in/judbowman/" target="_blank">
                                                <div class="image-block-wrapper">
                                                    <img class="thumb-image loaded" alt="Jud" src="images/jud.jpeg">
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                    <div class="sqs-block">
                                        <div class="sqs-block-content">
                                            <a href="https://www.linkedin.com/in/judbowman/" target="_blank"><span class="employee">Jud Bowman</span></a>
                                            <p class="text-small">Founder &amp; CEO</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="column w-col w-col-3">
                                    <div class="sqs-block sqs-block-image">
                                        <div class="image-block-outer-wrapper">
                                            <a href="https://www.linkedin.com/in/slawekpruchnik/" target="_blank">
                                                <div class="image-block-wrapper">
                                                    <img class="thumb-image loaded" alt="Slawek" src="images/slawek.jpeg">
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                    <div class="sqs-block">
                                        <div class="sqs-block-content">
                                            <a href="https://www.linkedin.com/in/slawekpruchnik/" target="_blank"><span class="employee">Slawek Pruchnik</span></a>
                                            <p class="text-small">Co-founder, Chief Technology Officer</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="column w-col w-col-3">
                                    <div class="sqs-block sqs-block-image">
                                        <div class="image-block-outer-wrapper">
                                            <div>
                                                <a href="https://www.linkedin.com/in/jesper-rasmussen" target="_blank">
                                                    <div class="image-block-wrapper">
                                                        <img class="thumb-image loaded" alt="Jesper" src="images/jesper.jpeg">
                                                    </div>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="sqs-block">
                                        <div class="sqs-block-content">
                                            <a href="https://www.linkedin.com/in/jesper-rasmussen" target="_blank"><span class="employee">Jesper Rasmussen</span></a>
                                            <p class="text-small">Co-founder, Chief Software Architect</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="column w-col w-col-3">
                                    <div class="sqs-block sqs-block-image">
                                        <div class="image-block-outer-wrapper">
                                            <a href="https://www.linkedin.com/in/zofia-pruchnik-4a82762b/" target="_blank">
                                                <div class="image-block-wrapper">
                                                    <img class="thumb-image loaded" alt="Sofia" src="images/sofia.jpg">
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                    <div class="sqs-block">
                                        <div class="sqs-block-content">
                                            <a href="https://www.linkedin.com/in/zofia-pruchnik-4a82762b/" target="_blank"><span class="employee">Sofia Pruchnik</span></a>
                                            <p class="text-small">Accounting &amp; Finance</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="w-row employee-row">
                                <div class="column w-col w-col-3">
                                    <div class="sqs-block sqs-block-image">
                                        <div class="image-block-outer-wrapper">
                                            <a href="https://www.linkedin.com/in/dylan-li/" target="_blank">
                                                <div class="image-block-wrapper">
                                                    <img class="thumb-image loaded" alt="Dylan" src="images/dylan.jpg">
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                    <div class="sqs-block">
                                        <div class="sqs-block-content">
                                            <a href="https://www.linkedin.com/in/dylan-li/" target="_blank"><span class="employee">Dylan Li</span></a>
                                            <p class="text-small">Director of APAC</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="column w-col w-col-3">
                                    <div class="sqs-block sqs-block-image">
                                        <div class="image-block-outer-wrapper">
                                            <a href="https://www.linkedin.com/in/aarongerstman/" target="_blank">
                                                <div class="image-block-wrapper">
                                                    <img class="thumb-image loaded" alt="Aaron" src="images/AaronGerstman.jpg">
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                    <div class="sqs-block">
                                        <div class="sqs-block-content">
                                            <a href="https://www.linkedin.com/in/aarongerstman/" target="_blank"><span class="employee">Aaron Gerstman</span></a>
                                            <p class="text-small">Controller</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="column w-col w-col-3">
                                    <div class="sqs-block sqs-block-image">
                                        <div class="image-block-outer-wrapper">
                                            <a href="https://www.linkedin.com/in/brendan-schultz-411847236/" target="_blank">
                                                <div class="image-block-wrapper">
                                                    <img class="thumb-image loaded" alt="Brendan" src="images/BrendanSchultz.jpg">
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                    <div class="sqs-block">
                                        <div class="sqs-block-content">
                                            <a href="https://www.linkedin.com/in/brendan-schultz-411847236/" target="_blank"><span class="employee">Brendan Schultz</span></a>
                                            <p class="text-small">Business Development &amp; Partnerships Manager</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="column w-col w-col-3">
                                    <div class="sqs-block sqs-block-image">
                                        <div class="image-block-outer-wrapper">
                                            <a href="https://www.linkedin.com/in/neale-fernandes-16aa04a4/" target="_blank">
                                                <div class="image-block-wrapper">
                                                    <img class="thumb-image loaded" alt="Neale" src="images/NealeFernandes.jpg">
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                    <div class="sqs-block">
                                        <div class="sqs-block-content">
                                            <a href="https://www.linkedin.com/in/neale-fernandes-16aa04a4/" target="_blank"><span class="employee">Neale Fernandes</span></a>
                                            <p class="text-small">Director of Partnerships</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="w-row employee-row">
                                <div class="column w-col w-col-3">
                                    <div class="sqs-block sqs-block-image">
                                        <div class="image-block-outer-wrapper">
                                            <a href="https://www.linkedin.com/in/aiden-tubergen-183930235/" target="_blank">
                                                <div class="image-block-wrapper">
                                                    <img class="thumb-image loaded" alt="Jason" src="images/AidenTubergen.jpg">
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                    <div class="sqs-block">
                                        <div class="sqs-block-content">
                                            <a href="https://www.linkedin.com/in/aiden-tubergen-183930235/" target="_blank"><span class="employee">Aiden Tubergen</span></a>
                                            <p class="text-small">DevOps Engineer</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="column w-col w-col-3">
                                    <div class="sqs-block sqs-block-image">
                                        <div class="image-block-outer-wrapper">
                                            <a href="https://www.linkedin.com/in/jakub-pruchnik-932948275/" target="_blank">
                                                <div class="image-block-wrapper">
                                                    <img class="thumb-image loaded" alt="Jason" src="images/JakubPruchnik.webp">
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                    <div class="sqs-block">
                                        <div class="sqs-block-content">
                                            <a href="https://www.linkedin.com/in/jakub-pruchnik-932948275/" target="_blank"><span class="employee">Jakub Pruchnik</span></a>
                                            <p class="text-small">Software Engineer</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="column w-col w-col-3">
                                    <div class="sqs-block sqs-block-image">
                                        <div class="image-block-outer-wrapper">
                                            <a href="https://www.linkedin.com/in/jasonchina/" target="_blank">
                                                <div class="image-block-wrapper">
                                                    <img class="thumb-image loaded" alt="Jason" src="images/jason.jpg">
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                    <div class="sqs-block">
                                        <div class="sqs-block-content">
                                            <a href="https://www.linkedin.com/in/jasonchina/" target="_blank"><span class="employee">Jason Qiao</span></a>
                                            <p class="text-small">Strategic Advisor</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="section no-margins">
            <div class="w-container main-content">
                <div id="team" class="index-section">
                    <div class="index-section-wrapper page-content">
                        <div class="w-row employee-row">
                            <div class="col w-col w-col-12">
                                <div class="sqs-block">
                                    <div>
                                        <p style="text-align:center;font-size:20px;white-space:pre-wrap;">Board of Directors</p>
                                    </div>
                                </div>
                            </div>

                            <div class="w-row employee-row">
                                <div class="column w-col w-col-3">
                                    <div class="sqs-block">
                                        <div class="sqs-block-content">
                                            <span class="employee">Wiley Becker</span>
                                            <p class="text-small">Board Member</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="column w-col w-col-3">
                                    <div class="sqs-block">
                                        <div class="sqs-block-content">
                                            <span class="employee">Jud Bowman</span>
                                            <p class="text-small">Founder & CEO</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="column w-col w-col-3">
                                    <div class="sqs-block">
                                        <div class="sqs-block-content">
                                            <span class="employee">Slawek Pruchnik</span>
                                            <p class="text-small">Co-founder & CTO</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="column w-col w-col-3">
                                    <div class="sqs-block">
                                        <div class="sqs-block-content">
                                            <span class="employee">Robert Long</span>
                                            <p class="text-small">Board Member</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="w-row employee-row">
                                <div class="column w-col w-col-3">
                                    <div class="sqs-block">
                                        <div class="sqs-block-content">
                                            <span class="employee">Steve Nelson</span>
                                            <p class="text-small">Board Member</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="section section-color center">
            <div class="w-container" style="padding:10px 0 10px 0">
                <div class="key-number" style="padding-top: 0">Investors</div>
            </div>
        </div>

        <div class="section no-margins">
            <div class="w-container main-content">
                <div id="team" class="index-section">
                    <div class="index-section-wrapper page-content">
                        <div class="w-row employee-row">
                            <div class="col w-col w-col-12">
                                <div class="sqs-block">
                                    <div>
                                        <p style="text-align:center;margin-top:20px;white-space:pre-wrap;">LocalScale has received more than $5 million in venture capital from investors including Alerion Ventures, Cofounders Capital, IDEA Fund Partners, Piedmont Capital, Tweener Fund, Wakefield Group, and several angel investors.</p>
                                    </div>
                                </div>
                            </div>

                            <div class="w-row employee-row">
                                <div class="column w-col w-col-4">
                                    <div class="sqs-block">
                                        <div class="sqs-block-content">
                                            <img src="images/investors/PiedmontCapital.png" alt="Piedmont Capital" class="investor-logo">
                                        </div>
                                    </div>
                                </div>
                                <div class="column w-col w-col-4">
                                    <div class="sqs-block">
                                        <div class="sqs-block-content">
                                            <img src="images/investors/AlerionVentures.png" alt="Alerion Ventures" class="investor-logo">
                                        </div>
                                    </div>
                                </div>
                                <div class="column w-col w-col-4">
                                    <div class="sqs-block">
                                        <div class="sqs-block-content">
                                            <img src="images/investors/CofoundersCapital.png" alt="Cofounders Capital" class="investor-logo">
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="w-row employee-row">
                                <div class="column w-col w-col-4">
                                    <div class="sqs-block">
                                        <div class="sqs-block-content">
                                            <img src="images/investors/IDEAFundPartners.png" alt="IDEA Fund Partners" class="investor-logo">
                                        </div>
                                    </div>
                                </div>
                                <div class="column w-col w-col-4">
                                    <div class="sqs-block">
                                        <div class="sqs-block-content">
                                            <img src="images/investors/TweenerFund.png" alt="Tweener Fund" class="investor-logo">
                                        </div>
                                    </div>
                                </div>
                                <div class="column w-col w-col-4">
                                    <div class="sqs-block">
                                        <div class="sqs-block-content">
                                            <img src="images/investors/Wakefield.png" alt="Wakefield" class="investor-logo">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="section section-color center">
            <div class="w-container" style="padding:10px 0 10px 0">
                <div class="key-number" style="padding-top: 0">Awards</div>
            </div>
        </div>

        <div class="section no-margins">
            <div class="w-container main-content">
                <div id="team" class="index-section">
                    <div class="index-section-wrapper page-content">
                        <div class="w-row employee-row" style="margin-top: 60px">
                            <div class="w-row employee-row">
                                <div class="column w-col w-col-3">
                                    <div class="sqs-block">
                                        <div class="sqs-block-content">
                                            <img src="images/awards/AF+14+PNG+4.png" class="award-logo">
                                        </div>
                                    </div>
                                </div>
                                <div class="column w-col w-col-3">
                                    <div class="sqs-block">
                                        <div class="sqs-block-content">
                                            <img src="images/awards/deloitte2021.png" class="award-logo">
                                        </div>
                                    </div>
                                </div>
                                <div class="column w-col w-col-3">
                                    <div class="sqs-block">
                                        <div class="sqs-block-content">
                                            <img src="images/awards/Sift+2021+Fast+50.png" class="award-logo">
                                        </div>
                                    </div>
                                </div>
                                <div class="column w-col w-col-3">
                                    <div class="sqs-block">
                                        <div class="sqs-block-content">
                                            <img src="images/awards/logo_nc_fast40_2021_award_winner.png" class="award-logo">
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="w-row employee-row">
                                <div class="column w-col w-col-3">
                                    <div class="sqs-block">
                                        <div class="sqs-block-content">
                                            <img src="images/awards/Inc_5000_2021+cropped.jpg" class="award-logo">
                                        </div>
                                    </div>
                                </div>
                                <div class="column w-col w-col-3">
                                    <div class="sqs-block">
                                        <div class="sqs-block-content">
                                            <img src="images/awards/2021+Awards+Finalist+Badge.jpg" class="award-logo">
                                        </div>
                                    </div>
                                </div>
                                <div class="column w-col w-col-3">
                                    <div class="sqs-block">
                                        <div class="sqs-block-content">
                                            <img src="images/awards/deloitte2020.png" class="award-logo">
                                        </div>
                                    </div>
                                </div>
                                <div class="column w-col w-col-3">
                                    <div class="sqs-block">
                                        <div class="sqs-block-content">
                                            <img src="images/awards/Inc_5000_2020+cropped.jpg" class="award-logo">
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="w-row employee-row">
                                <div class="column w-col w-col-3">
                                    <div class="sqs-block">
                                        <div class="sqs-block-content">
                                            <img src="images/awards/Sift2020Fast50_big15.png" class="award-logo">
                                        </div>
                                    </div>
                                </div>
                                <div class="column w-col w-col-3">
                                    <div class="sqs-block">
                                        <div class="sqs-block-content">
                                            <img src="images/awards/Sift2019Fast50_big9+v2.png" class="award-logo">
                                        </div>
                                    </div>
                                </div>
                                <div class="column w-col w-col-3">
                                    <div class="sqs-block">
                                        <div class="sqs-block-content">
                                            <img src="images/awards/Tech+Awards+Winners+Badge+for+website.png" class="award-logo">
                                        </div>
                                    </div>
                                </div>
                                <div class="column w-col w-col-3">
                                    <div class="sqs-block">
                                        <div class="sqs-block-content">
                                            <img src="images/awards/Triangle+Tweeners+2018.jpg" class="award-logo">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <Footer/>

    </div>
</template>

<script>
    import HeaderMenu from "../components/HeaderMenu";
import NetworkStatus from "../components/NetworkStatus.vue";
    import Footer from "../components/Footer";

    export default {
        components: {
            HeaderMenu, NetworkStatus, Footer
        }
    }
</script>

<style>
    body {
        font-family: Inter, sans-serif;
    }
    a {
        text-decoration: none;
        color: #1f1f1f
    }
    .employee {
        font-weight: bold;
        font-size: 15px;
        color: #363636;
    }
    .key-number, .sub-header {
        color:#fff;
        font-weight: bold;
    }
    .integration-item > .padding {
        padding: 20px;
        max-height: 150px;
    }
    .award-logo {
        max-height: 150px;
    }
    .thumb-image {
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        position: absolute;
    }
    .section.no-margins {
        padding-top: 0;
        padding-bottom: 0;
    }
    .sqs-block {
        padding: 10px;
    }
    .sqs-block-content {
        text-align: center;
    }
    .sqs-block-image .image-block-outer-wrapper .image-block-wrapper {
        line-height: 0;
        text-align: center;
        position: relative;
        overflow: hidden;
        padding-bottom: 100%;
    }
    .employee-row {
        padding-bottom: 20px;
    }
    @media screen and (max-width: 767px) {
        .w-col {
            width: 100%;
        }
    }
    @media (max-width: 479px) {
        .page-content {
            margin: 0 20px 0 20px;
            width: 300px;
        }
        .column {
            width: 100%;
        }
        .integration-item {
            padding-left: 4px;
            padding-right: 4px;
        }
        .integration-item > .padding {
            padding: 4px;
            height: 50px;
            object-fit: contain;
        }
        .investor-logo {
            max-height: 125px;
        }
        .award-logo {
            max-height: 125px;
        }
        .sqs-block {
            padding: 0;
        }
    }
</style>
